import { inject } from '@angular/core';
import { CanActivateChildFn, RedirectCommand, Router } from '@angular/router';

import { TokenService } from '../services/token/token.service';
import { AuthService } from '../services/auth/auth.service';

export const childRoutesGuard: CanActivateChildFn = () => {
  const tokenService: TokenService = inject(TokenService);
  const router = inject(Router);
  const authService: AuthService = inject(AuthService);

  const isUserLogged =
    tokenService.isAccessTokenValid() || tokenService.isRefreshTokenValid();
  if (!isUserLogged) {
    authService.clearAuthData();
    const loginPath = router.parseUrl('/login');
    return new RedirectCommand(loginPath, {
      skipLocationChange: true,
    });
  }
  return true;
};
